import type { FC } from 'react';
import styles from './index.module.css';

const ArrowDown: FC = () => {
  return <div className={styles.arrowDown} />;
};

export default ArrowDown;
